import React from 'react'
import {ChevronLeft, ChevronRight, CrossIcon} from 'assets/icons'
import 'styles/main.scss'

const SlideOverHeader = ({children, hide, hideShow, navigation, extraActions, closeLabel}) => {

    return (
        <>
            <div className="flex justify-between p-5 gap-5 flex-shrink-0">
                <h3 className="ft-lg tab:ft-2xl text-[#202124] font-semibold my-auto flex-1 min-w-0">
                    {children}
                </h3>
                {/* Pinned to the top rather than centred: a header whose title
                    carries a back link and a description above and below it is
                    taller than one line, and my-auto pushed the close cross
                    down to the middle of it. */}
                <div className="flex items-center gap-2 self-start">
                    {navigation && navigation.total > 1 && (
                        <div className="flex items-center gap-2">
                            <button
                                type={'button'}
                                onClick={navigation.onPrevious}
                                disabled={navigation.currentIndex === 0}
                                className="flex items-center justify-center border rounded p-1 disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-100"
                            >
                                <ChevronLeft wh={20} color={'#374151'} />
                            </button>
                            <span className="text-sm text-gray-600 min-w-[40px] text-center">
                                {navigation.currentIndex + 1}/{navigation.total}
                            </span>
                            <button
                                type={'button'}
                                onClick={navigation.onNext}
                                disabled={navigation.currentIndex === navigation.total - 1}
                                className="flex items-center justify-center border rounded p-1 disabled:opacity-50 disabled:cursor-not-allowed hover:bg-gray-100"
                            >
                                <ChevronRight wh={20} color={'#374151'} />
                            </button>
                        </div>
                    )}
                    {extraActions}
                    {/* `hideShow` was accepted and ignored. A panel reached by a
                        back link closes through it, and a cross beside that link
                        offers two ways out of one screen. */}
                    {hideShow !== false && (
                        <button
                            type={'button'}
                            aria-label={closeLabel}
                            className="flex items-center justify-center border rounded p-1"
                            onClick={hide}
                        >
                            <CrossIcon wh={20} color={'#111827'}/>
                        </button>
                    )}
                </div>
            </div>
        </>
    )
}

export default SlideOverHeader